import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// TODO replace with own Accordion component
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Stack from '@mui/material/Stack';
import { forwardRef, useEffect, useState, } from 'react';
import { Paper } from '../..';
import { Typography } from '../../atoms/Typography';
import { Tooltip } from '../../legacy/components';
export const Card = forwardRef(function Card({ tooltip, title, expandable, isOpen: isOpenProp = true, actions, children, }, ref) {
    const [isOpenInternal, setIsOpenInternal] = useState(isOpenProp);
    useEffect(() => {
        setIsOpenInternal(isOpenProp);
    }, [isOpenProp]);
    if (tooltip && tooltip.type !== Tooltip) {
        console.error('Typeof Tooltip expects a tooltip');
        return null;
    }
    return (_jsx(Paper, { children: _jsxs(Accordion, { expanded: isOpenInternal, ref: ref, elevation: 0, disableGutters: true, children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(AccordionSummary, { onClick: () => expandable && setIsOpenInternal(!isOpenInternal), expandIcon: 
                            // we dont want the chevron icon if it is not expandable
                            expandable && _jsx(ExpandMoreIcon, {}), sx: {
                                gap: 103,
                                // so the chevron is on the left
                                flexDirection: 'row-reverse',
                                p: 0,
                            }, style: {
                                // we dont want the pointer cursor if it is not expandable
                                cursor: isOpenProp !== undefined || !expandable ? 'auto' : 'pointer',
                            }, children: _jsxs(Stack, { direction: "row", spacing: 103, alignItems: "center", children: [_jsx(Typography, { variant: "h4", color: "darkBlue", children: title }), tooltip !== undefined && tooltip] }) }), actions] }), _jsx(AccordionDetails, { sx: { p: 0 }, children: children })] }) }));
});
